<template>
<div class="fc-page ca-page ca-page-student_cash_list"><header class="fc-child-heading"><h2>金额账户余额</h2><p>按学员、账户状态和余额范围查询金额账户</p></header><section class="fc-filters" aria-label="金额账户余额筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按学员、账户状态和余额范围查询金额账户</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-text-field v-model="query.studentNo" label="学号" dense outlined color="#d9363e" hide-details></v-text-field></div><div class="fc-filter-cell"><studentSearchBox class="fc-student-search" @inputValue="setInputValue"></studentSearchBox></div><div class="fc-filter-cell"><v-select :items="statusItems" v-model="query.status" item-text="statusName" item-value="id"
									label="状态" dense outlined color="#d9363e" hide-details></v-select></div><div class="fc-filter-cell"><v-text-field v-model="query.balanceFrom" label="余额下限" dense outlined color="#d9363e" hide-details></v-text-field></div><div class="fc-filter-cell"><v-text-field v-model="query.balanceTo" label="余额上限" dense outlined color="#d9363e" hide-details></v-text-field></div></div><div class="fc-filter-bottom"><span>查询当前校区的记录</span><div class="fc-filter-actions"><v-btn type="submit" depressed dark color="#d9363e" :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form></section><section class="fc-records"><div class="fc-list-heading"><h3>账户余额明细</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span><span class="fc-list-note">全部合计对应当前筛选条件下的所有记录</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table ca-table ca-student_cash_list fc-has-actions" :mobile-breakpoint="0"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" no-data-text="暂无符合条件的记录">

				<template v-slot:item.status="{item}">

					<span v-if="item.status == '0'" class="fc-status fc-status-inactive">{{ statusName(item.status) }}</span>
					<span v-if="item.status == '1'" class="fc-status fc-status-normal">{{ statusName(item.status) }}</span>
				</template>
				<template v-slot:item.action="{item}">
					<v-menu top>
						<template v-slot:activator="{ attrs, on }">
							<v-btn v-bind="attrs" v-on="on" color="#c93640" outlined small>
								操作
							</v-btn>
						</template>
						<v-list color="white" class="fc-action-menu align-center">
							<v-list-item class="justify-center" v-if="item.status==='1'">
								<v-btn @click.stop="showAddDialog(item)" color="#c93640" outlined small>金额充值</v-btn>
							</v-list-item>
							<v-list-item class="justify-center" v-if="item.status==='1'">
								<v-btn @click.stop="showReduceDialog(item)" color="#c93640" outlined small class="ml-1">扣减金额</v-btn>
							</v-list-item>
							<v-list-item class="justify-center" v-if="item.status=='1'">
								<v-btn @click.stop="cancelAccount(item)" color="#c93640" outlined small class="ml-1">冻结账户</v-btn>
							</v-list-item>
							<v-list-item class="justify-center" v-if="item.status=='0'">
								<v-btn  @click.stop="openAccount(item)" color="#c93640" outlined small class="ml-1">启用账户</v-btn>

							</v-list-item>
							<v-list-item class="justify-center" v-if="parseFloat(item.balanceFee) > 0">
								<v-btn  @click.stop="showRefund(item)" color="#c93640" outlined small class="ml-1">金额退费</v-btn>
							</v-list-item>
						</v-list>
					</v-menu>

				</template>

				<template v-slot:body.prepend="{ headers }">
					<tr class="account-summary-row">
						<td v-for="(header, index) in headers" :key="header.value">
							<span v-if="index === 0" title="当前筛选条件下的全部记录">全部合计</span>
							<span v-else>{{ summaryCells[header.value] }}</span>
						</td>
					</tr>
				</template>
			<template v-slot:item.studentName="{item}"><strong class="fc-student-name">{{item.studentName}}</strong></template><template v-slot:item.memo="{item}"><div class="fc-memo">{{item.memo}}</div></template><template v-slot:item.totalTuitionFee="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.totalTuitionFee)<0}">{{item.totalTuitionFee}}</span></template><template v-slot:item.usedFee="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.usedFee)<0}">{{item.usedFee}}</span></template><template v-slot:item.balanceFee="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.balanceFee)<0}">{{item.balanceFee}}</span></template><template v-slot:item.realPayFee="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.realPayFee)<0}">{{item.realPayFee}}</span></template><template v-slot:item.usedRealFee="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.usedRealFee)<0}">{{item.usedRealFee}}</span></template><template v-slot:item.balanceRealFee="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.balanceRealFee)<0}">{{item.balanceRealFee}}</span></template></v-data-table><div class="fc-pagination"><div class="fc-page-size"><span>每页</span><v-select :items="[10,20,50,100]" @change="handleSizeChange" dense hide-details aria-label="每页数量" outlined v-model="query.size" color="#d9363e" /><span>条</span><span class="fc-total">共 {{data.total}} 条记录</span></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="5" v-model="query.page" color="#d9363e" /></div></section><v-dialog title="学费充值" v-model="add.dialog" max-width="600" persistent scrollable>
			<v-card class="fc-dialog-card ca-dialog">

				<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-wallet-plus-outline</v-icon></span><div><h2>金额充值</h2><p>核对学员信息、充值金额和付款方式</p></div><v-spacer /><v-btn icon aria-label="关闭金额充值" @click="add.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>
				<v-card-text class="fc-dialog-body">
					<v-sheet class="fc-form-sheet">
						<v-row dense>
							<v-col cols="12" class="">
								<span class="fc-form-note">注：学费用于支付“按金额扣费”的课程,不可用于“按课时扣费”的课程</span>
							</v-col>
							<v-col cols="6" class="pr-3">
								<v-text-field label="学号" disabled v-model="add.recharge.studentNo" dense
									outlined color="#d9363e"></v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3">
								<v-text-field label="姓名" disabled v-model="add.recharge.studentName" dense
									outlined color="#d9363e"></v-text-field>
							</v-col>
							<v-col cols="12" class="pr-3 ">
								<v-text-field label="当前学费余额" v-model="add.recharge.balanceFee" disabled dense outlined color="#d9363e">
								</v-text-field>
							</v-col>

							<v-col cols="6" class="">
								<v-select :items="selectTeacherList" v-model="add.recharge.salesTeacherId" item-text="trueName"
									item-value="id" label="开单老师" dense outlined clearable color="#d9363e"></v-select>
							</v-col>
							<v-col cols="6" class="">
								<v-select :items="selectTeacherList" v-model="add.recharge.classTeacherId" item-text="trueName"
									item-value="id" label="上课老师" dense outlined clearable color="#d9363e"></v-select>
							</v-col>

							<v-col cols="6" class="pr-3 ">
								<v-text-field label="充值金额" v-model="add.recharge.orderAmount" type="number" dense outlined color="#d9363e">
								</v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3 ">
								<v-text-field label="赠送金额" v-model="add.recharge.giveFee" type="number" dense outlined color="#d9363e">
								</v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3 ">
								<v-select label="请选择优惠券" v-model="add.selectedCoupon"
								:items="studentCouponItems" item-text="couponName" item-value="id"
								no-data-text="没有可用优惠券" :disabled="!add.recharge.orderAmount"
								return-object clearable @change="cashCouponChanged"
								dense outlined color="#d9363e"></v-select>
							</v-col>
							<v-col cols="6" class="pr-3 ">
								<v-text-field label="优惠券金额" v-model="couponAmount" disabled dense outlined color="#d9363e">
								</v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3 ">
								<v-text-field label="本次增加学费金额" v-model="addTuitionFee" disabled type="number" dense outlined color="#d9363e">
								</v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3 ">

								<span class="">需付款金额:</span>
								<span style="color: red;" class="ml-2  text-h6">{{realPayFee}}</span>
								<span class=" ml-1">元</span>
							</v-col>
							<v-col cols="4" class="pr-3 ">
								<v-select v-model="add.recharge.payType" :items="payTypeList" label="付款方式" item-text="text"
									item-value="code" clearable outlined dense no-data-text="暂无付款方式" color="#d9363e"></v-select>
							</v-col>
							<v-col cols="8" class="pr-3 ">
								<v-text-field label="备注" v-model="add.recharge.memo" dense outlined color="#d9363e">
								</v-text-field>
							</v-col>
						</v-row>
					</v-sheet>
				</v-card-text>

				<v-card-actions class="fc-dialog-actions">
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAddRecharge" :disabled="add.submitting" :loading="add.submitting" class="fc-confirm" depressed color="#d9363e">确认充值</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog><v-dialog title="扣除学费" v-model="reduce.dialog" max-width="600" persistent scrollable>
			<v-card class="fc-dialog-card ca-dialog">
				<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-wallet-outline</v-icon></span><div><h2>扣除金额</h2><p>核对账户余额和本次扣减金额</p></div><v-spacer /><v-btn icon aria-label="关闭扣除金额" @click="reduce.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>
				<v-card-text class="fc-dialog-body">
					<v-sheet class="fc-form-sheet">
						<v-row class="" dense>
							<v-col cols="6">
								<v-text-field label="学号" disabled v-model="reduce.order.studentNo" dense
									outlined color="#d9363e"></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="姓名" disabled v-model="reduce.order.studentName" dense
									outlined color="#d9363e"></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="当前学费余额" v-model="reduce.order.balanceFee" disabled dense outlined color="#d9363e">
								</v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="当前现金余额" v-model="reduce.order.balanceRealFee" disabled dense outlined color="#d9363e">
								</v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="本次扣除金额" v-model="reduce.order.reduceAmount" type="number" dense outlined color="#d9363e">
								</v-text-field>
							</v-col>

							<v-col cols="12">
								<v-text-field label="备注" v-model="reduce.order.memo" dense outlined color="#d9363e">
								</v-text-field>
							</v-col>
						</v-row>
					</v-sheet>
				</v-card-text>
				<v-card-actions class="fc-dialog-actions">
					<v-spacer></v-spacer>
					<v-btn @click="reduce.dialog=false">取消</v-btn>
					<v-btn @click="submitReduceAmount" :disabled="reduce.submitting" :loading="reduce.submitting" class="fc-confirm" depressed color="#d9363e">确认扣费</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog><cashAccountRefund :show="refund.show" :account="refund.account" @cancel="refund.show=false" @success="refundSuccess"></cashAccountRefund></div>
</template>

<script>
	import global from '../../../config/global'
	import utils from "../../../config/utils"
	import cashAccountRefund from "../../../components/cash_account_refund.vue"
	import studentSearchBox from "../../../components/student_search_box.vue"
	export default {
		name: "student-cash-list",
		components:{cashAccountRefund,studentSearchBox},
		data() {
			return {
				
				imgPrev: global.config.imgPre,
				data: {
					total: 0,
					headers: [
						{
							text: '学号',
							value: 'studentNo',
							sortable: false
						},
						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '总学费',
							value: 'totalTuitionFee',
							sortable: false
						},
						{
							text: '已用学费',
							value: 'usedFee',
							sortable: false
						},
						{
							text: '剩余学费',
							value: 'balanceFee',
							sortable: false
						},
						{
							text: '实缴金额',
							value: 'realPayFee',
							sortable: false
						},
						{
							text: '已用金额',
							value: 'usedRealFee',
							sortable: false
						},
						{
							text: '剩余金额',
							value: 'balanceRealFee',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						},
					],
					list: [],
					summary: null,
				},
				listRequestId: 0,
				studentCouponItems:[], // 选择的优惠券
				selectTeacherList:[],
				statusItems: [{
						id: "",
						statusName: "全部"
					},
					{
						id: "1",
						statusName: "正常"
					},
					{
						id: "0",
						statusName: "作废"
					},
				],

				query: {
					loading: false,
					page: 1,
					size: 20,
					studentNo: "",
					studentName: "",
					status: "1",
					balanceFrom:"",
					balanceTo:""
				},
				payTypeList:[
					{code:'ALIPAY',text:'支付宝'},
					{code:'WXPAY',text:'微信'},
					{code:'CASH',text:'现金'},
				],
				add: {
					dialog: false,
					submitting: false,
					selectedCoupon:null, //选择的优惠券
					recharge: {
						cashId: "", // 账号ID
						studentNo: "",
						studentName: "",
						balanceFee:"",  //当前余额
						orderAmount: "", //学费金额
						giveFee:"",  	//赠送金额
						memo:"",
						payType:"",
						salesTeacherId:"",
						classTeacherId:""
					},
				},
				reduce:{
					dialog:false,
					submitting: false,
					order: {
						cashId: "", // 账号ID
						studentNo: "",
						studentName: "",
						balanceFee:"",  //当前余额
						balanceRealFee:"",
						reduceAmount: "", //扣除金额
						memo:"",
					},
				},
				refund:{
					show:false,
					account:null
				}
			}
		},
		created() {

			this.getTableDataList();
			this.getTeacherListForSelect();
		},
		computed:{
			summaryCells(){
				const cells = {};
				const moneyFields = ['totalTuitionFee', 'usedFee', 'balanceFee', 'realPayFee', 'usedRealFee', 'balanceRealFee'];
				const hourFields = [];
				moneyFields.concat(hourFields).forEach(field => {
					const value = this.data.summary && this.data.summary[field];
					if (this.query.loading || value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) {
						cells[field] = '—';
					} else {
						cells[field] = moneyFields.includes(field) ? Number(value).toFixed(2) : String(value);
					}
				});
				return cells;
			},

			realPayFee(){
				if(!this.add.recharge.orderAmount){
					return "0";
				}
				let orderAmount = this.add.recharge.orderAmount;
				let couponAmount = 0;
				if (this.add.selectedCoupon){
					couponAmount = this.add.selectedCoupon.amount;
				}
				let result = orderAmount - couponAmount;
				return result >0 ?result:0 ;
			},
			addTuitionFee(){
				if(!this.add.recharge.orderAmount){
					return "";
				}
				let orderAmount = parseFloat(this.add.recharge.orderAmount);
				let giveFee = 0;
				if (this.add.recharge.giveFee){
					giveFee = parseFloat(this.add.recharge.giveFee);
				}
				let result = orderAmount + giveFee;
				return result > 0 ? result:0;
			},
			couponAmount(){
				if(!this.add.selectedCoupon){
					return "0";
				}
				
				return this.add.selectedCoupon.amount;
			}
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			setInputValue(value){
				// 搜索框输入的值
				
				this.query.studentName = value;
			},
			cashCouponChanged(e){
			
				// 课时 优惠券选择
				let limitAmount = parseFloat(e.limitAmount);
				const cashAmount = parseFloat(this.add.recharge.orderAmount);
				if (limitAmount > 0){
					// 有金额限制 判断金额限制
					if (cashAmount < limitAmount){
						// 不符合
						
						this.$noty.error('优惠券需满'+limitAmount+'元才能使用');
						const that = this;
						setTimeout(()=>{
							that.add.selectedCoupon = null;
						},100)
					}
				}
				
			},
			showRefund(item){
				this.refund.account = item;
				this.refund.show=true;
			},
			refundSuccess(){
				this.getTableDataList();
				this.refund.show=false;
				
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showAddDialog(item) {
				this.add.dialog = true;

				this.add.recharge.cashId = item.id;
				this.add.recharge.studentNo = item.studentNo;
				this.add.recharge.studentName = item.studentName;
				this.add.recharge.balanceFee = item.balanceFee;
				this.add.recharge.salesTeacherId = "";
				this.add.recharge.classTeacherId = "";
				
				
				// 获取学员优惠券
				this.add.selectedCoupon = null;
				this.getStudentCouponListForSelect(item.studentId);
				
			},
			showReduceDialog(item){
				// 扣费
				this.reduce.dialog = true;
				this.reduce.order.cashId = item.id;
				this.reduce.order.studentNo = item.studentNo;
				this.reduce.order.studentName = item.studentName;
				this.reduce.order.balanceFee = item.balanceFee;
				this.reduce.order.balanceRealFee = item.balanceRealFee;
				
				this.reduce.order.reduceAmount = "";
				this.reduce.order.memo = "";
			},
			submitAddRecharge(){
				// 提交充值
				if(!this.add.recharge.orderAmount){
					this.$noty.error("请输入学费金额")
					return
				}
				// 判断正2位小数金额
				const isFloat = utils.isDecimal(this.add.recharge.orderAmount);
				if (!isFloat){
					this.$noty.error('缴费金额格式错误,最多2位小数的正数');
					return;
				}
				// 如果输入了赠送金额
				if (this.add.recharge.giveFee){
					if(!utils.isDecimal(this.add.recharge.giveFee)){
						this.$noty.error('赠送金额格式错误,最多2位小数的正数');
						return;
					}
				}
				
				
				this.add.submitting = true;
				
				// api
				const that = this;
				let url = `/financial/student/cash/recharge`;
				let postData = {
					cashId:this.add.recharge.cashId,
					orderAmount :this.add.recharge.orderAmount,
					giveFee:this.add.recharge.giveFee,
					memo:this.add.recharge.memo,
					payType:this.add.recharge.payType,
					salesTeacherId:this.add.recharge.salesTeacherId,
					classTeacherId:this.add.recharge.classTeacherId
				}
				
				if(this.add.selectedCoupon){
					postData.studentCouponId = this.add.selectedCoupon.id;
				}
				
				this.axios.post(url, postData).catch(() => {
					that.add.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							that.add.submitting = false;
							return;
						} else {
							that.add.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitting = false;
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			submitReduceAmount(){
				// 提交扣除学费
				if(!this.reduce.order.reduceAmount){
					this.$noty.error("请输入扣除学费金额")
					return
				}
				
				// 判断正2位小数金额
				const isFloat = utils.isDecimal(this.reduce.order.reduceAmount);
				if (!isFloat){
					this.$noty.error('请输入最多2位小数的金额');
					return;
				}

				this.reduce.submitting = true;
				// api
				const that = this;
				let url = `/financial/student/cash/reduce`;
				let postData = {
					cashId:this.reduce.order.cashId,
					reduceAmount :this.reduce.order.reduceAmount,
					memo:this.reduce.order.memo,
				}
				
				this.axios.post(url, postData).catch(() => {
					that.reduce.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							that.reduce.dialog = false;
							that.reduce.submitting = false;
							return;
						} else {
							that.reduce.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.reduce.submitting = false;
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			getTableDataList() {
				
				if(this.query.balanceFrom){
					if(!utils.isDecimal(this.query.balanceFrom)){
						this.$noty.error('金额请输入最多两位小数的非负数字');
						return
					}
				}
				
				if(this.query.balanceTo){
					if(!utils.isDecimal(this.query.balanceTo)){
						this.$noty.error('金额请输入最多两位小数的非负数字');
						return
					}
				}
				
				if (this.query.balanceFrom !== '' && this.query.balanceTo !== '' && Number(this.query.balanceFrom) > Number(this.query.balanceTo)) {
					this.$noty.error('余额下限不能大于上限');
					return;
				}

				const requestId = ++this.listRequestId;
				this.query.loading = true;
				this.data.summary = null;
				const params = { shopId: utils.getCurrentShopId() };
				['studentNo', 'studentName', 'status', 'balanceFrom', 'balanceTo'].forEach(key => {
					const value = this.query[key];
					if (value !== '' && value !== null && value !== undefined) {
						params[key] = value;
					}
				});
				const url = `/financial/student/cash/list/page/${this.query.page - 1}/size/${this.query.size}`;
				return this.axios.get(url, { params }).then(response => {
					if (requestId !== this.listRequestId) return;
					if (response.data.code !== 200) {
						throw new Error(response.data.message || '获取失败');
					}
					const pageData = response.data.data;
					this.data.list = pageData.list || [];
					this.data.total = pageData.count;
					this.data.summary = pageData.summary || null;
				}).catch(error => {
					if (requestId !== this.listRequestId) return;
					this.data.list = [];
					this.data.total = 0;
					this.data.summary = null;
					this.$noty.error('获取失败：' + ((error && error.message) || '网络请求失败'));
				}).finally(() => {
					if (requestId === this.listRequestId) this.query.loading = false;
				});
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "作废";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			cancelAccount(item){
				// 作废课时账户
				const cashId = item.id;
				const that = this;
				let url = `/financial/cash/account/cancel/` + cashId;
				
				this.axios.post(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.getTableDataList();
						return
					}
				
					that.$noty.error("操作失败：" + response.data["message"]);
				})
			},
			openAccount(item){
				// 作废课时账户
				const cashId = item.id;
				const that = this;
				let url = `/financial/cash/account/open/` + cashId;
				
				this.axios.post(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.getTableDataList();
						return
					}
				
					that.$noty.error("操作失败：" + response.data["message"]);
				})
			},
			getShopListForSelect() {
				const that = this;
				let url = `/sys/merchant/shop/list`;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectShopList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getStudentCouponListForSelect(studentId) {
				// 获取学生优惠券
				if (!studentId) {
					return
				}
				const that = this;
				let url = `/financial/student/all/coupon/list/` + studentId;
			
				this.axios.get(url).then(response => {
					
					console.log("student coupon:",response);
					if (response.data["code"] === 200) {
						that.studentCouponItems = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getTeacherListForSelect() {
			
				const shopId = utils.getCurrentShopId();
				
				if (!shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/teacher/list/` + shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		
		}
	}
</script>

<style lang="scss" scoped src="../../../assets/styles/cash-account.scss"></style>
